import logo from "@public/logo/full_logo.png";
import logoOnly from "@public/logo/logo.png";

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    iconOnly?: boolean;
}

const Logo = ({ iconOnly = false, ...props }: LogoProps) => (
    <img src={iconOnly ? logoOnly : logo} alt="logo" {...props} />
);

export default Logo;
